'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _PackageTitleForPayment = require('./PackageTitleForPayment.scss');var _PackageTitleForPayment2 = _interopRequireDefault(_PackageTitleForPayment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PackageTitleForPayment = function PackageTitleForPayment(_ref) {var _cx;var properties = _ref.properties,highlight = _ref.highlight,price = _ref.price,isAgent = _ref.isAgent;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_PackageTitleForPayment2.default.packageWrapper, (_cx = {}, _cx[_PackageTitleForPayment2.default.publisherPackageWrapper] = !isAgent, _cx)) },
      _react2.default.createElement('div', { className: _PackageTitleForPayment2.default.titleWrapper },
        _react2.default.createElement('div', null, properties),
        _react2.default.createElement('div', null, highlight)),

      _react2.default.createElement('div', { className: _PackageTitleForPayment2.default.priceWrapper },
        _react2.default.createElement('div', null, price))));};




PackageTitleForPayment.propTypes = {
  properties: _propTypes2.default.node,
  highlight: _propTypes2.default.node,
  price: _propTypes2.default.string,
  isAgent: _propTypes2.default.bool };exports.default =


PackageTitleForPayment;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackageTitleForPayment/PackageTitleForPayment.js
// module id = 2786
// module chunks = 0